import React, { useCallback, useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import FilterContainer from "../../Components/FilterContainer";
import {
  checkArray,
  checkNull,
  createSelectOptions,
  decimalValue,
  getMerchantCurrencySymbol,
  isFutureFromToday,
} from "../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  changeMenuValue,
  editMenuItemLifespan,
  getMenuItems,
  getMenuItemSubCategory,
  getMenuItemSubClass,
  menuInitialValue,
  updateMenuItemCategory,
  updateMenuItemClass,
  updateMenuItemLifespan,
  updateMenuItemStatus,
} from "../../../Redux/actions";
import ModelContainer from "../../Components/ModelContainer";
import ListSelect from "../../Components/ListSelect";
import ErrorContainer from "../../Components/ErrorContainer";
import ConfirmModel from "../../Components/ConfirmModel";
import ListDateInput from "../../Components/ListDateInput";
import moment from "moment";

const updateItemClassSchema = yup
  .object({
    menu_item_ids: yup.array(),
    class_id: yup.string().required(),
    sub_class_id: yup.string().required(),
  })
  .required();
const updateItemCategorySchema = yup
  .object({
    menu_item_ids: yup.array(),
    category_id: yup.string().required(),
    sub_category_id: yup.string().required(),
  })
  .required();
const updateItemLifespanSchema = yup
  .object({
    pos_service_period: yup.array().of(
      yup.object().shape({
        id: yup.string().required(),
        menu_item_id: yup.string().required(),
        period_start: yup.string(),
        period_end: yup.string(),
      })
    ),
  })
  .required();
const Items = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.authReducer.user_details);
  const {
    menu_item_details,
    updateItemClassModal,
    item_subclass_detail,
    updateItemCategoryModal,
    item_subcategory_detail,
    reload_list_flag,
    updateItemStatusModal,
    item_lifespan_details,
    updateItemLifespanModal,
  } = useSelector((state) => state.menuReducer);

  const merchantCurrency = getMerchantCurrencySymbol(user_details);
  const pagesize = 10;

  const [filterInput, setFilterInput] = useState({
    class_id: "",
    category_id: "",
    sub_category_id: "",
    status_id: "",
    tag_id: "",
    menu_item_type: "",
    min_price: "",
    max_price: "",
    keyword: "",
    page: 1,
    pagesize: pagesize,
  });

  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    dispatch(getMenuItems(filterInput));
    return () => {
      dispatch(menuInitialValue());
    };
  }, []);

  useEffect(() => {
    if (reload_list_flag !== null) {
      dispatch(getMenuItems(filterInput));
      closeUpdateItemClass(false);
      closeUpdateItemCategory(false);
      closeUpdateItemStatus(false);
      setSelectedIds([]);
    }
  }, [reload_list_flag]);

  const getPaginationContainer = () => {
    let res = null;
    if (
      checkNull(menu_item_details?.menuItems?.last_page, false) &&
      menu_item_details?.menuItems?.last_page > 1
    ) {
      const pagesArr = Array.from(
        { length: menu_item_details?.menuItems?.last_page },
        (_, i) => i + 1
      );
      res = (
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            {pagesArr.map((pageNo) => {
              return (
                <li
                  class={`page-item${
                    pageNo == menu_item_details?.menuItems?.current_page
                      ? " active"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      !(pageNo == menu_item_details?.menuItems?.current_page)
                    ) {
                      filterChangeInputHandler("page", pageNo);
                      dispatch(getMenuItems({ ...filterInput, page: pageNo }));
                    }
                  }}
                >
                  <a class="page-link">{pageNo}</a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    }
    return res;
  };

  const filterChangeInputHandler = (input, val) => {
    console.log("testtttt", input, val);
    setFilterInput((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const filterInputsArr = [
    {
      name: "class_id",
      empty: "Class",
      value: filterInput?.class_id,
      options: createSelectOptions(menu_item_details?.classes),
      onChange: filterChangeInputHandler,
    },
    {
      name: "category_id",
      empty: "Category",
      value: filterInput?.category_id,
      options: createSelectOptions(menu_item_details?.otherCategories),
      onChange: filterChangeInputHandler,
    },
    {
      name: "sub_category_id",
      empty: "Sub Category",
      value: filterInput?.sub_category_id,
      options: createSelectOptions(menu_item_details?.subCategories),
      onChange: filterChangeInputHandler,
    },
    {
      name: "status_id",
      empty: "Status",
      value: filterInput?.status_id,
      options: createSelectOptions(menu_item_details?.statuses),
      onChange: filterChangeInputHandler,
    },
    {
      name: "tag_id",
      empty: "Tag",
      value: filterInput?.tag_id,
      options: createSelectOptions(menu_item_details?.tags),
      onChange: filterChangeInputHandler,
    },
    {
      name: "menu_item_type",
      empty: "Menu Item Type",
      value: filterInput?.menu_item_type,
      options: createSelectOptions(menu_item_details?.menu_item_types),
      onChange: filterChangeInputHandler,
    },
  ];

  const filterSubmitHandler = () => {
    dispatch(getMenuItems(filterInput));
  };
  const filterSliderChangeHandler = (sliderVals) => {
    console.log("sliderVals", sliderVals);
    filterChangeInputHandler("min_price", sliderVals?.min ?? 0);
    filterChangeInputHandler("max_price", sliderVals?.max ?? 0);
  };
  const getMenuClassName = (item) => {
    let res = null;
    if (checkNull(item?.menu_class?.name, false)) {
      res = `${item?.menu_class?.name}${
        checkNull(item?.sub_class?.name, false)
          ? " - " + item?.sub_class?.name
          : ""
      }`;
    }
    return res;
  };

  const getAmountContainer = (item) => {
    let res = null;
    if (menu_item_details?.transaction_type?.sales_financial_source_id == 2) {
      res = (
        <>
          <td>
            {decimalValue(item?.total_cost_per_menu_item, 2, merchantCurrency)}
          </td>
          <td>
            {checkArray(item?.pos_menu_items_price) &&
              item?.pos_menu_items_price.map((itemPrice) => {
                if (checkArray(itemPrice?.menu_item_price)) {
                  return itemPrice?.menu_item_price.map((price1) => {
                    if (checkArray(price1)) {
                      price1.map((price2, index) => (
                        <>
                          <span>{index ?? ""}</span>
                          <br />
                        </>
                      ));
                    }
                  });
                }
              })}
          </td>
          <td>
            {checkArray(item?.pos_menu_items_price) &&
              item?.pos_menu_items_price.map((itemPrice) => {
                if (checkArray(itemPrice?.menu_item_price)) {
                  return itemPrice?.menu_item_price.map((price1) => {
                    if (checkArray(price1)) {
                      price1.map((price2) => (
                        <>
                          <span>
                            {decimalValue(price2 ?? 0, 2, merchantCurrency)}
                          </span>
                          <br />
                        </>
                      ));
                    }
                  });
                }
              })}
          </td>
        </>
      );
    } else {
      res = (
        <>
          <td>
            {decimalValue(
              item?.total_cost_per_menu_item ?? 0,
              2,
              merchantCurrency
            )}
          </td>
          <td>{decimalValue(item?.menu_price ?? 0, 5, merchantCurrency)}</td>
          <td>{item?.profit_margin ?? 0}%</td>
        </>
      );
    }
    return res;
  };

  const getAllergyTags = (item) => {
    let res = null;
    if (checkNull(item?.allergy_tags, false)) {
      const allergyTagArr = item?.allergy_tags.split(",");
      if (checkArray(allergyTagArr)) {
        res = (
          <>
            {allergyTagArr.map((tag) => {
              const currentTag = menu_item_details?.allergy_tags?.[tag];
              if (checkNull(currentTag, false)) {
                return (
                  <span
                    className="allerg_tags allerg_tags_tooltip"
                    style={{ backgroundColor: `${currentTag?.color}` }}
                    title={`${currentTag?.name}`}
                  >
                    {currentTag?.symbol}
                  </span>
                );
              }
            })}
          </>
        );
      }
    }
    return res;
  };

  const itemClickHandler = (itemId) => {
    const newItemIds = [...selectedIds];
    if (selectedIds.includes(itemId)) {
      newItemIds.splice(selectedIds.indexOf(itemId));
    } else {
      newItemIds.push(itemId);
    }
    setSelectedIds(newItemIds);
  };

  const itemSelectAllHandler = () => {
    let newItemIds = [];
    if (selectedIds.length !== menu_item_details?.menuItems?.data.length) {
      newItemIds = checkArray(menu_item_details?.menuItems?.data)
        ? menu_item_details?.menuItems?.data.map((p) => p.id)
        : [];
    }
    setSelectedIds(newItemIds);
  };

  // UpdateItemClass
  const initialUpdateItemClassForm = {
    menu_item_ids: [],
    class_id: "",
    sub_class_id: "",
  };
  const [updateItemClassInputForm, setUpdateItemClassInputForm] = useState(
    initialUpdateItemClassForm
  );

  const closeUpdateItemClass = useCallback(
    (value) => {
      dispatch(changeMenuValue("updateItemClassModal", value));
      if (!value) {
        resetUpdateItemClassHandler();
        dispatch(changeMenuValue("item_subclass_detail", null));
      }
    },
    [updateItemClassModal]
  );

  const resetUpdateItemClassHandler = (
    resetVal = initialUpdateItemClassForm
  ) => {
    setUpdateItemClassInputForm(resetVal);
    updateItemClassReset(resetVal);
  };

  const {
    register: updateItemClassReg,
    formState: { errors: updateItemClassErrors },
    handleSubmit: updateItemClassSubmit,
    control: updateItemClassControl,
    setValue: updateItemClassSetValue,
    reset: updateItemClassReset,
    trigger: updateItemClassTrigger,
  } = useForm({
    resolver: yupResolver(updateItemClassSchema),
    defaultValues: initialUpdateItemClassForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeUpdateItemClassInputHandler = (input, val) => {
    updateItemClassSetValue(input, val);
    setUpdateItemClassInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
    if (input == "class_id") {
      dispatch(getMenuItemSubClass({ class_id: val }));
    }
  };

  const getErrorMsgForUpdateItemClass = (input) => {
    let res = null;
    const errorMsg = updateItemClassErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={updateItemClassErrors} name={input} />;
    }
    return res;
  };

  const updateItemClassSubmitHandler = (data) => {
    console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>");
    console.log("<<<<<<<updateItemClassSubmitHandler>>>", data, ">>>>>>>");
    console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>");
    data.menu_item_ids = selectedIds.join(",");
    dispatch(updateMenuItemClass(data));
  };

  // UpdateItemCategory
  const initialUpdateItemCategoryForm = {
    menu_item_ids: [],
    category_id: "",
    sub_category_id: "",
  };
  const [updateItemCategoryInputForm, setUpdateItemCategoryInputForm] =
    useState(initialUpdateItemCategoryForm);

  const closeUpdateItemCategory = useCallback(
    (value) => {
      dispatch(changeMenuValue("updateItemCategoryModal", value));
      if (!value) {
        resetUpdateItemCategoryHandler();
        dispatch(changeMenuValue("item_subcategory_detail", null));
      }
    },
    [updateItemCategoryModal]
  );

  const resetUpdateItemCategoryHandler = (
    resetVal = initialUpdateItemCategoryForm
  ) => {
    setUpdateItemCategoryInputForm(resetVal);
    updateItemCategoryReset(resetVal);
  };

  const {
    register: updateItemCategoryReg,
    formState: { errors: updateItemCategoryErrors },
    handleSubmit: updateItemCategorySubmit,
    control: updateItemCategoryControl,
    setValue: updateItemCategorySetValue,
    reset: updateItemCategoryReset,
    trigger: updateItemCategoryTrigger,
  } = useForm({
    resolver: yupResolver(updateItemCategorySchema),
    defaultValues: initialUpdateItemCategoryForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeUpdateItemCategoryInputHandler = (input, val) => {
    updateItemCategorySetValue(input, val);
    setUpdateItemCategoryInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
    if (input == "category_id") {
      dispatch(getMenuItemSubCategory({ category_id: val }));
    }
  };

  const getErrorMsgForUpdateItemCategory = (input) => {
    let res = null;
    const errorMsg = updateItemCategoryErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={updateItemCategoryErrors} name={input} />;
    }
    return res;
  };

  const updateItemCategorySubmitHandler = (data) => {
    data.menu_item_ids = selectedIds.join(",");
    dispatch(updateMenuItemCategory(data));
  };

  // Update Status
  const closeUpdateItemStatus = useCallback(
    (value) => {
      dispatch(changeMenuValue("updateItemStatusModal", value));
    },
    [updateItemStatusModal]
  );

  const submitUpdateItemStatusHandler = () => {
    const data = { ids: selectedIds };
    dispatch(updateMenuItemStatus(data));
  };

  // Update Lifespan
  useEffect(() => {
    if (
      item_lifespan_details !== null &&
      checkArray(item_lifespan_details?.PosServicePeriods)
    ) {
      const lifespanArr = [];
      item_lifespan_details?.PosServicePeriods.map((period) => {
        const prevPeriodStart = checkNull(period?.period_start, false)
          ? moment(period?.period_start).format("yyyy-MM-DD")
          : "";
        const prevPeriodEnd = checkNull(period?.period_end, false)
          ? moment(period?.period_end).format("yyyy-MM-DD")
          : "";
        lifespanArr.push({
          id: period?.id ?? "",
          menu_item_id: period?.menu_item_id ?? "",
          period_start:
            prevPeriodStart !== "" &&
            isFutureFromToday(period?.period_start, true)
              ? moment(prevPeriodStart).toDate()
              : "",
          old_period_start: prevPeriodStart,
          period_end:
            prevPeriodEnd !== "" && isFutureFromToday(period?.period_end, true)
              ? moment(prevPeriodEnd).toDate()
              : "",
          old_period_end: prevPeriodEnd,
          menu_item_name: checkNull(period?.menu_item?.menu_item_name),
          class_name: checkNull(period?.menu_item?.menu_class?.name),
          sub_class_name: checkNull(period?.menu_item?.sub_class?.name),
        });
      });
      changeUpdateItemLifespanInputHandler("pos_service_period", lifespanArr);
    }
  }, [item_lifespan_details]);

  const initialUpdateItemLifespanForm = {
    pos_service_period: [],
  };

  const [updateItemLifespanInputForm, setUpdateItemLifespanInputForm] =
    useState(initialUpdateItemLifespanForm);

  const {
    register: updateItemLifespanReg,
    formState: { errors: updateItemLifespanErrors },
    handleSubmit: updateItemLifespanSubmit,
    control: updateItemLifespanControl,
    setValue: updateItemLifespanSetValue,
    reset: updateItemLifespanReset,
    trigger: updateItemLifespanTrigger,
  } = useForm({
    resolver: yupResolver(updateItemLifespanSchema),
    defaultValues: initialUpdateItemLifespanForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeUpdateItemLifespanInputHandler = (input, val) => {
    updateItemLifespanSetValue(input, val);
    setUpdateItemLifespanInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };

  const getErrorMsgForPosServicePeriod = (index, input) => {
    let res = null;
    const errorMsg =
      updateItemLifespanErrors?.pos_service_period?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = <ErrorContainer message={errorMsg?.message} name={input} />;
    }
    return res;
  };

  const changePosServicePeriodHandler = (index, type, value) => {
    const checkSubPeriod =
      updateItemLifespanInputForm?.pos_service_period?.[index];
    if (checkNull(checkSubPeriod, false)) {
      const newSubPeriod = { ...checkSubPeriod, [type]: value };
      const newPeriod = [...updateItemLifespanInputForm.pos_service_period];
      newPeriod[index] = newSubPeriod;
      changeUpdateItemLifespanInputHandler("pos_service_period", newPeriod);
    }
  };

  const [deletePosServicePeriodModal, setDeletePosServicePeriodModal] =
    useState(false);
  const [selectedDeletePeriodIndex, setSelectedDeletePeriodIndex] =
    useState(null);
  const closeDeletePosServicePeriod = useCallback(
    (value) => {
      setDeletePosServicePeriodModal(value);
      if (!value) {
        setSelectedDeletePeriodIndex(null);
      }
    },
    [deletePosServicePeriodModal]
  );
  const submitDeletePosServicePeriodHandler = () => {
    if (checkNull(selectedDeletePeriodIndex, false)) {
      const newPeriodArr = [...updateItemLifespanInputForm?.pos_service_period];
      newPeriodArr.splice(selectedDeletePeriodIndex, 1);
      changeUpdateItemLifespanInputHandler("pos_service_period", newPeriodArr);
    }
    closeDeletePosServicePeriod(false);
  };

  const deletePosServicePeriodHandler = (index) => {
    setSelectedDeletePeriodIndex(index);
    setDeletePosServicePeriodModal(true);
  };

  const refreshPosServicePeriodHandler = (index) => {
    const changeInput = checkNull(
      updateItemLifespanInputForm?.pos_service_period?.[index],
      false
    )
      ? { ...updateItemLifespanInputForm?.pos_service_period?.[index] }
      : false;
    if (changeInput) {
      const prevPeriodStart =
        changeInput.old_period_start !== ""
          ? moment(changeInput.old_period_start).format("yyyy-MM-DD")
          : "";
      const prevPeriodEnd =
        changeInput.old_period_end !== ""
          ? moment(changeInput.old_period_end).format("yyyy-MM-DD")
          : "";
      const new_period_start =
        prevPeriodStart !== "" && isFutureFromToday(prevPeriodStart, true)
          ? moment(prevPeriodStart).toDate()
          : "";
      const new_period_end =
        prevPeriodEnd !== "" && isFutureFromToday(prevPeriodEnd, true)
          ? moment(prevPeriodEnd).toDate()
          : "";
      changePosServicePeriodHandler(index, "period_start", new_period_start);
      changePosServicePeriodHandler(index, "period_end", new_period_end);
    }
  };

  const closeUpdateItemLifespan = useCallback(
    (value) => {
      dispatch(changeMenuValue("updateItemLifespanModal", value));
      if (value) {
        dispatch(editMenuItemLifespan({ ids: selectedIds }));
      }
    },
    [updateItemLifespanModal, selectedIds]
  );

  const updateItemLifespanSubmitHandler = (data) => {
    console.log("updateItemLifespanSubmitHandler", data);
    const postData = data.pos_service_period.map((itm) => ({
      id: itm.id ?? "",
      menu_item_id: itm.menu_item_id ?? "",
      period_start: checkNull(itm.period_start, false)
        ? moment(itm.period_start).format("yyyy-MM-DD")
        : itm.old_period_start,
      period_end: checkNull(itm.period_end, false)
        ? moment(itm.period_end).format("yyyy-MM-DD")
        : itm.old_period_end,
    }));
    console.log("postData", postData);
    dispatch(updateMenuItemLifespan({ pos_service_period: postData }));
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <FilterContainer
              inputs={filterInputsArr}
              submitHandler={filterSubmitHandler}
              filterMin={menu_item_details?.myMinPrice ?? 0}
              filterMax={
                menu_item_details?.myMaxPrice &&
                menu_item_details?.myMaxPrice > 0
                  ? menu_item_details?.myMaxPrice
                  : 100
              }
              filterSymbol={"$"}
              filterOnChange={filterSliderChangeHandler}
            />

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Menu Item List</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box mt-0">
                          <form
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                              onChange={(e) =>
                                filterChangeInputHandler(
                                  "keyword",
                                  e?.target?.value
                                )
                              }
                              value={filterInput?.keyword}
                            />{" "}
                            <input
                              type="button"
                              onClick={() => filterSubmitHandler()}
                            />
                          </form>
                        </div>{" "}
                      </div>
                      <div class="btns col-sm-7 col-12 align-right px-0 d-flex align-items-center justify-content-end">
                        <div class="btn-group">
                          <button
                            class="dropdown-toggle btn bordered-btn"
                            id="bulk_action_btn"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {" "}
                            Bulk Action <i class="bi bi-chevron-down"></i>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="bulk_action_btn"
                          >
                            <li>
                              {" "}
                              <a
                                onClick={() => closeUpdateItemStatus(true)}
                                id="deactivate"
                              >
                                {" "}
                                Deactivate{" "}
                              </a>{" "}
                            </li>
                            <li>
                              {" "}
                              <a
                                onClick={() => closeUpdateItemClass(true)}
                                id="update_class"
                              >
                                {" "}
                                Update Class{" "}
                              </a>{" "}
                            </li>
                            <li>
                              {" "}
                              <a
                                href="#_"
                                onClick={() => closeUpdateItemCategory(true)}
                                id="update_category"
                              >
                                {" "}
                                Update Category{" "}
                              </a>{" "}
                            </li>
                            <li>
                              {" "}
                              <a
                                onClick={() => closeUpdateItemLifespan(true)}
                                id="update_end_date"
                              >
                                {" "}
                                Update Menu Item LifeSpans
                              </a>{" "}
                            </li>
                          </ul>
                        </div>
                        <a
                          class="btn green-btn-revert add-plus addAccounts mx-0"
                          onClick={() => history.push("/menu/items/new-item")}
                        >
                          <i class="i-icon"> </i> Add Menu Item
                        </a>{" "}
                      </div>
                    </div>

                    <div className="shadowclass mt-0 px-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th>
                                <a class="checkbox avaiCheck">
                                  <input
                                    type="checkbox"
                                    name="master_check"
                                    class="avail_checkbox"
                                    id="checkbox_menu_id"
                                    onClick={() => itemSelectAllHandler()}
                                    checked={
                                      checkArray(
                                        menu_item_details?.menuItems?.data
                                      )
                                        ? selectedIds.length ==
                                          menu_item_details?.menuItems?.data
                                            .length
                                        : false
                                    }
                                  />
                                  <label for="checkbox_menu_id"></label>
                                </a>
                              </th>
                              <th> ID </th>
                              {user_details?.user?.merchant
                                ?.parent_merchant_id > 0 && (
                                <th> Parent ID </th>
                              )}
                              <th> Menu Item Name and Class </th>
                              <th> Menu Item Type </th>
                              <th> Status </th>
                              <th> POS Categorization </th>
                              <th>
                                Total Cost <br /> Per Item
                              </th>
                              <th> Sales Type </th>
                              <th> Menu Price </th>
                              <th className="min-wd-150"> Tag </th>
                              <th> Actions </th>
                            </tr>
                          </thead>
                          <tbody>
                            {checkArray(menu_item_details?.menuItems?.data) &&
                              menu_item_details?.menuItems?.data.map(
                                (item, itemInd) => {
                                  return (
                                    <tr>
                                      <td>
                                        <a class="checkbox avaiCheck">
                                          <input
                                            type="checkbox"
                                            class="avail_checkbox child_box"
                                            id={`item_id_${itemInd}`}
                                            onClick={() =>
                                              itemClickHandler(item.id)
                                            }
                                            checked={
                                              selectedIds.indexOf(item.id) > -1
                                            }
                                          />{" "}
                                          <label for={`item_id_${itemInd}`}>
                                            {" "}
                                          </label>
                                        </a>
                                      </td>
                                      <td> {item?.id} </td>
                                      {user_details?.user?.merchant
                                        ?.parent_merchant_id > 0 && (
                                        <td>
                                          {checkNull(item?.parent_id, "NA")}{" "}
                                        </td>
                                      )}
                                      <td>
                                        <strong>{item?.menu_item_name} </strong>
                                        <br />
                                        {getMenuClassName(item)}
                                      </td>

                                      <td>
                                        {
                                          menu_item_details?.menu_item_types?.[
                                            item?.menu_item_type
                                          ]
                                        }
                                      </td>

                                      <td>
                                        {item?.status_id == 5 ? (
                                          <span class="green_tag">
                                            {" "}
                                            Active{" "}
                                          </span>
                                        ) : (
                                          <span class="bordered_tag">
                                            Inactive
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        {item?.other_category?.name} -{" "}
                                        {item?.sub_category?.name}{" "}
                                      </td>
                                      {getAmountContainer(item)}
                                      <td> {getAllergyTags(item)} </td>
                                      <td>
                                        {" "}
                                        <a
                                          class="circle_icon"
                                          onClick={() => history.push(`/menu/items/edit-item/${item?.id}`)}
                                        >
                                          <i
                                            class="iconSprites edit-icon"
                                          >
                                            <div class="tooltip-sm"> Edit </div>
                                          </i>
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                          </tbody>
                        </table>
                        {getPaginationContainer()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Update Class`}
        open={updateItemClassModal}
        submitModal={updateItemClassSubmit(updateItemClassSubmitHandler)}
        closeModal={closeUpdateItemClass}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <ListSelect
              label={"Class"}
              name="class_id"
              className="required update_classes select2-offscreen"
              onChange={(e) =>
                changeUpdateItemClassInputHandler("class_id", e?.target?.value)
              }
              value={updateItemClassInputForm?.class_id}
              options={createSelectOptions(menu_item_details?.classes)}
              errorMsg={getErrorMsgForUpdateItemClass("class_id")}
            />
            <ListSelect
              label={"Sub-Class"}
              name="sub_class_id"
              className="required update_classes select2-offscreen"
              onChange={(e) =>
                changeUpdateItemClassInputHandler(
                  "sub_class_id",
                  e?.target?.value
                )
              }
              value={updateItemClassInputForm?.sub_class_id}
              options={createSelectOptions(item_subclass_detail)}
              errorMsg={getErrorMsgForUpdateItemClass("sub_class_id")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Update Category`}
        open={updateItemCategoryModal}
        submitModal={updateItemCategorySubmit(updateItemCategorySubmitHandler)}
        closeModal={closeUpdateItemCategory}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <ListSelect
              label={"Category"}
              name="category_id"
              className="required update_classes select2-offscreen"
              onChange={(e) =>
                changeUpdateItemCategoryInputHandler(
                  "category_id",
                  e?.target?.value
                )
              }
              value={updateItemCategoryInputForm?.category_id}
              options={createSelectOptions(menu_item_details?.otherCategories)}
              errorMsg={getErrorMsgForUpdateItemCategory("category_id")}
            />
            <ListSelect
              label={"Sub-Category"}
              name="sub_category_id"
              className="required update_classes select2-offscreen"
              onChange={(e) =>
                changeUpdateItemCategoryInputHandler(
                  "sub_category_id",
                  e?.target?.value
                )
              }
              value={updateItemCategoryInputForm?.sub_category_id}
              options={createSelectOptions(item_subcategory_detail)}
              errorMsg={getErrorMsgForUpdateItemCategory("sub_category_id")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ConfirmModel
        title="Deactivate Menu Items"
        text="Are you sure you want to deactivate all menu items selected?"
        open={updateItemStatusModal}
        closeModal={closeUpdateItemStatus}
        submitModal={submitUpdateItemStatusHandler}
        is_loading={false}
      />
      <ModelContainer
        title={`Update Menu Item LifeSpans`}
        open={updateItemLifespanModal}
        submitModal={updateItemLifespanSubmit(updateItemLifespanSubmitHandler)}
        closeModal={closeUpdateItemLifespan}
        is_loading={false}
        is_large={true}
      >
        <fieldset class="">
          <table
            class="checklist-table inventory_table remove-space update-menu-lifespans-tbl"
            width="100%"
            id="update_menuItem_lifespan_body"
          >
            {" "}
            <thead>
              <tr>
                <th>Menu Item Name</th>
                <th>Life Span Start Date</th>
                <th>Life Span End Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {checkArray(updateItemLifespanInputForm?.pos_service_period) &&
                updateItemLifespanInputForm?.pos_service_period.map(
                  (serPeriod, serPerInd) => {
                    return (
                      <tr>
                        <td>
                          <strong>{serPeriod?.menu_item_name}</strong>
                          <br />
                          {checkNull(serPeriod?.class_name, false)
                            ? `${serPeriod?.class_name} ${
                                checkNull(serPeriod?.sub_class_name, false)
                                  ? " - " + serPeriod?.sub_class_name
                                  : ""
                              }`
                            : ""}
                        </td>
                        <td>
                          {serPeriod?.period_start !== "" ? (
                            <ListDateInput
                              name="period_start"
                              autoComplete="new-password"
                              className="required"
                              divClassName="ms-0"
                              dateFormat="yyyy-MM-dd"
                              onChange={(val) =>
                                changePosServicePeriodHandler(
                                  serPerInd,
                                  "period_start",
                                  val
                                )
                              }
                              selected={serPeriod?.period_start}
                              errorMsg={getErrorMsgForPosServicePeriod(
                                serPerInd,
                                "period_start"
                              )}
                            />
                          ) : (
                            moment(serPeriod?.old_period_start).format(
                              "DD-MM-yyyy"
                            )
                          )}
                        </td>
                        <td>
                          {serPeriod?.period_end !== "" ? (
                            <ListDateInput
                              name="period_end"
                              autoComplete="new-password"
                              className="required"
                              divClassName="ms-0"
                              dateFormat="yyyy-MM-dd"
                              onChange={(val) =>
                                changePosServicePeriodHandler(
                                  serPerInd,
                                  "period_end",
                                  val
                                )
                              }
                              selected={serPeriod?.period_end}
                              errorMsg={getErrorMsgForPosServicePeriod(
                                serPerInd,
                                "period_end"
                              )}
                            />
                          ) : (
                            moment(serPeriod?.old_period_end).format(
                              "DD-MM-yyyy"
                            )
                          )}
                        </td>
                        <td class="action-td">
                          <div class="d-flex">
                            <a
                              class="deleteServicePeriod circle_icon red"
                              onClick={() =>
                                deletePosServicePeriodHandler(serPerInd)
                              }
                            >
                              <i class="iconSprites cancel-icon"></i>
                            </a>
                            <a
                              class="resetServicePeriod circle_icon"
                              onClick={() =>
                                refreshPosServicePeriodHandler(serPerInd)
                              }
                            >
                              <i class="iconSprites refresh-icon"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                )}
            </tbody>
          </table>
        </fieldset>
      </ModelContainer>
      <ConfirmModel
        title="Confirm Period Delete"
        text="Are you sure you want to remove period from bulk update?"
        open={deletePosServicePeriodModal}
        closeModal={closeDeletePosServicePeriod}
        submitModal={submitDeletePosServicePeriodHandler}
        is_loading={false}
      />
    </UserInterface>
  );
};
export default Items;
